import styled from 'styled-components';

import Button from '@decisiv/ui-components/lib/components/Button';

export const ClearAllButton = styled(Button)`
  margin-left: auto;
` as unknown as typeof Button;
